import React, { useState, useEffect } from 'react';
import { newUser } from '../Redux/Actions/Auth/Auth';
import { connect } from 'react-redux';
import {
  Button,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle
} from 'reactstrap';
import styles from './modal.module.css';

const margecallFeature = ["Multi line dialer", "Mergecall extensions", "Podio Mergecall Integration",
  "Mergecall Podio Form builder", "Mergecall Tracking number",
  "Bulk Texting", "API AND WEBHOOKS"
];

const SSO = ({ isAuthenticated, newUser }) => {

  const [feature, setFeature] = useState([]);
  const [verified, setVerified] = useState(false);
  const [hasToken, setHasToken] = useState(false);
  const [wait, setWait] = useState(false);
  const [countdown, setCountdown] = useState(6);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     window.location.href = '/home';
  //   }
  // }, [isAuthenticated]);

  useEffect(() => {
    if (token) {
      fetch(process.env.REACT_APP_PORT + '/api/auth/ssoVerify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {


          console.log("sso verify data====================",data)
          if (data.verified) {
            if (data.token && data.email) 
              {
              setHasToken(true);
              setVerified(true);

              localStorage.setItem('verifyToken', data.verifyToken);

              localStorage.setItem('token', data.token);
              localStorage.setItem('email', data.email);
              window.location.href = '/home';
            } 
            else {
              setVerified(true);
              setWait(true);
            }
          } else {
            setWait(true);
            console.error('Unauthorized access or invalid token');
          }
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
          setWait(true);
        });
    }
  }, [token]);

  useEffect(() => {
    if (verified && hasToken) {
      const timer = setInterval(() => {
        setCountdown(prevCountdown => prevCountdown - 1);
      }, 1000);

      if (countdown === 0) {
        window.location.href = '/home';
      }

      return () => clearInterval(timer);
    }
  }, [verified, hasToken, countdown]);

  const selectFeatures = (name) => {
    setFeature(prev => [...prev, name]);
  };

  const removeFeature = (name) => {
    setFeature(prev => prev.filter(ele => ele !== name));
  };

  const handleGetStarted = () => {
    setButtonDisabled(true);
    newUser(token, feature);
  };

  return (
    <div className="container">
      {verified && hasToken && wait && (
        <Row>
          <Col md={6} sm={8} lg={6}>
            <Card style={{ width: '65vw', color: '#424242' }} className="container">
              <CardHeader>
                <CardTitle>
                  <p style={{ textAlign: 'center', fontSize: '1.5rem', color: '#2c7be5' }}>Verification Successful, Redirecting...</p>
                  <Row>
                    <Col>
                      <p style={{ fontSize: '0.9rem' }}>
                        You will be redirected to the home page in {countdown} seconds.
                      </p>
                      <p style={{ fontSize: '0.9rem' }}>
                        <Button onClick={() => window.location.href = '/home'}>
                          Go to Home Page Now
                        </Button>
                      </p>
                    </Col>
                  </Row>
                </CardTitle>
              </CardHeader>
            </Card>
          </Col>
        </Row>
      )}
      {verified && !hasToken && wait && (
        <Card style={{ width: '65vw', color: '#424242' }} className="container">
          <CardHeader>
            <CardTitle>
              <p style={{ textAlign: 'center', fontSize: '1.5rem', color: '#2c7be5' }}>Unlock the Full Potential of Mergecall!</p>
              <p style={{ fontSize: '1.2rem'}}>Experience seamless integration with leading platforms such as Podio, Zapier, and Google Chrome, alongside our versatile API and webhooks. Your possibilities are limitless. Let's kickstart your journey by selecting your desired features below</p>
              <Row>
                <Col>
                  <FormGroup>
                    {margecallFeature.map(feature => (
                      <div key={feature} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <Label for={feature} style={{ fontSize: '14px' , color: '#2c7be5'}}>
                          {feature}
                        </Label>
                        <Input type='checkbox' id={feature} onChange={(e) => {
                          e.target.checked ? selectFeatures(feature) : removeFeature(feature);
                        }} />
                      </div>
                    ))}
                  </FormGroup>
                  <Button onClick={handleGetStarted} disabled={buttonDisabled}>
                    Get Started
                  </Button>
                </Col>
              </Row>
            </CardTitle>
          </CardHeader>
        </Card>
      )}
      {!verified && wait && (
        <div>
          <Card style={{ width: '65vw', color: '#424242' }} className="container">
            <CardHeader>
              <CardTitle>
                <p style={{ textAlign: 'center', fontSize: '1.5rem', color: '#2c7be5' }}>Unauthorized access or invalid token</p>
                <Row>
                  <Col>
                    <Button onClick={() => window.location.href = 'https://mergeasy.com/'}>
                      Go to Mergeasy
                    </Button>
                  </Col>
                </Row>
              </CardTitle>
            </CardHeader>
          </Card>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(
  mapStateToProps,
  { newUser }
)(SSO);
